import animationData from "./empty.json";
import animationDataLoading from "./loading.json";
import animationForget from "./forget-password.json";
import animationResetPassword from "./resetPassword.json";
import animationAccessDenied from "./AccessDenied.json";
import animationLoadImage from "./loadImage.json";

export const defaultOptionsEmpty = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
export const defaultOptionsLoading = {
  loop: true,
  autoplay: true,
  animationData: animationDataLoading,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
export const defaultForgetPassword = {
  loop: true,
  autoplay: true,
  animationData: animationForget,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
export const defaultResetPassword = {
  loop: true,
  autoplay: true,
  animationData: animationResetPassword,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const defaultAccessDenied = {
  loop: true,
  autoplay: true,
  animationData: animationAccessDenied,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
export const defaultloadImage = {
  loop: true,
  autoplay: true,
  animationData: animationLoadImage,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
